<template>
  <div class="page-container">
    <!-- Alertas -->
    <div v-if="alertMessage" class="col-12">
      <b-alert show :variant="alertVariant">{{ alertMessage }}</b-alert>
    </div>

    <!-- Overlay de loading geral -->
    <div v-if="loading" class="overlay-modal d-flex align-items-center justify-content-center">
      <b-spinner label="Loading..." variant="dark"></b-spinner>
    </div>

    <div class="page-content pb-0">
      <!-- Cabeçalho -->
      <div class="page-header">
        <div class="d-flex align-items-center pb-3">
          <h1 class="text-white">
            <i :class="getIcon(currentMode)"></i> Renovação de Apólices
          </h1>
          <div class="d-flex gap-2 ml-auto align-items-center">
            <button
              class="btn btn-outline-white"
              @click="getNonRenewals()"
              title="Canceladas"
            >
              <i class="mdi mdi-file-document-multiple mr-2"></i>
              Relatório de Cancelamentos
            </button>
            <b-dropdown
              variant="outline-white"
              toggle-class="btn btn-outline-white d-flex align-items-center"
              right
              no-caret
            >
              <template #button-content>
                <i :class="getIcon(currentMode)"></i>
                <span class="d-none d-md-inline-block ml-2">Modo {{ currentMode }}</span>
                <i class="fa fa-chevron-down ml-2"></i>
              </template>
              <b-dropdown-item @click="setViewMode('painel')">
                <i class="mdi fa-fw mdi-file-table-box-multiple-outline mr-2"></i> Modo Painel
              </b-dropdown-item>
              <b-dropdown-item @click="setViewMode('listagem')">
                <i class="mdi fa-fw mdi-view-list mr-2"></i> Modo Listagem
              </b-dropdown-item>
              <b-dropdown-item @click="setViewMode('dashboard')">
                <i class="mdi fa-fw mdi-chart-arc mr-2"></i> Modo Dashboard
              </b-dropdown-item>
            </b-dropdown>
            <div class="d-flex flex-nowrap button-group button-group-renewal mb-1" v-if="currentMode === 'listagem' || currentMode === 'painel'">
              <button class="btn btn-outline-white" @click="openFilterModal()" style="border-radius: 30px 0px 0px 30px;">
                <i class="fas fa-filter"></i> Filtros
              </button>
              <button class="btn btn-outline-white" @click="clearFilters()" style="border-radius: 0px 30px 30px 0px;">
                <i class="fas fa-times"></i>
              </button>
            </div>
          </div>
        </div>

        <!-- Abas do Dashboard -->
        <ul v-if="currentMode === 'dashboard'" class="nav nav-tabs dashboard-nav-tabs mt-2">
          <li class="nav-item">
            <a
              class="nav-link text-hover-white font-lg-20 px-5"
              :class="{ active: dashboardTab === 'realizadas' }"
              @click="dashboardTab = 'realizadas'"
            >Renovações realizadas</a>
          </li>
          <li class="nav-item">
            <a
              class="nav-link text-hover-white font-lg-20 px-5"
              :class="{ active: dashboardTab === 'futuras' }"
              @click="dashboardTab = 'futuras'"
            >Renovações futuras</a>
          </li>
        </ul>
      </div>

      <!-- Body -->
      <div class="page-body">
        <div class="card-body p-0">
          <!-- Kanban Panel -->
          <KanbanPolicyRenewal
            v-if="currentMode === 'painel'"
            :items-policies="itemsPolicies"
            :items-policy-renovation="itemsPolicyRenovation"
            :pages="pages"
            @get-policy-due="getPoliciesDue"
            @get-policies-renovations="getPoliciesRenovations"
            @update-kanban="updateKanban"
            @show-error="showError"
            ref="painel"
          />

          <!-- Listagem -->
          <ListPolicyRenewal
            v-else-if="currentMode === 'listagem'"
            @update-loading="setLoading"
            @create-renovation="createRenovation"
            @show-error="showError"
            ref="listagem"
          />

          <!-- Dashboard -->
          <DashboardPolicyRenewal
              v-else-if="currentMode === 'dashboard'"
              :active-tab="dashboardTab"
              :custom-start-date="filters_dashboard.start_date"
              :custom-end-date="filters_dashboard.end_date"
              @update-loading="setLoading"
              @show-error="showError"
              ref="dashboard"
            />

        </div>
      </div>
    </div>

    <!-- Modal Filtros -->
    <b-modal id="filter-modal" ref="filterModal" size="md" hide-footer centered>
      <template #modal-title>Filtros</template>
      <div class="form-group">
        <label>Tomador</label>
        <b-form-input v-model="filters.policy_holder"></b-form-input>
      </div>
      <div class="form-group">
        <label>Segurado</label>
        <b-form-input v-model="filters.insured"></b-form-input>
      </div>
      <div class="form-group">
        <label>Número da apólice</label>
        <b-form-input v-model="filters.policy_number"></b-form-input>
      </div>
      <div class="form-group">
        <label>Status</label>
        <b-form-select v-model="filters.status_renovation">
          <b-form-select-option value="">Sem Filtro</b-form-select-option>
          <b-form-select-option
            v-for="(val, key) in translateRenovationStatus"
            :key="key"
            :value="val"
          >
            {{ key }}
          </b-form-select-option>
        </b-form-select>
      </div>
      <div v-if="filters.status_renovation === 9" class="form-group">
        <label>Motivo do cancelamento</label>
        <b-form-select v-model="filters.reason_cancellation">
          <b-form-select-option value="">Sem Filtro</b-form-select-option>
          <b-form-select-option
            v-for="(val, key) in translateReasonCancelTypes"
            :key="key"
            :value="val"
          >
            {{ key }}
          </b-form-select-option>
        </b-form-select>
      </div>
      <div class="d-block mt-3">
        <div class="d-flex justify-content-between">
        <b-button variant="outline-secondary" @click="$bvModal.hide('filter-modal')">Cancelar</b-button>
        <b-button variant="primary" @click="applyFilters()">Aplicar</b-button>
        </div>
      </div>
    </b-modal>
    <b-modal id="show-modal-dashboard" ref="modalDashboard" size="md" class="mt-4" hide-footer centered>
      <template #modal-title>Definir Período Customizado</template>
      <div>
        <div class="row form">
          <div class="col-12">
            <label class="dbo-ui">Data de Início</label>
            <input type="date" class="form-control" v-model="filters_dashboard.start_date">
          </div>
          <div class="col-12">
            <label class="dbo-ui">Data de Fim</label>
            <input type="date" class="form-control" v-model="filters_dashboard.end_date">
          </div>
        </div>
        <div class="d-block mt-3">
          <div class="d-flex justify-content-between">
            <button @click="$bvModal.hide('show-modal-dashboard')" class="btn btn-secondary btn-lg px-4 mr-1">
              <i class="fa fa-times mr-1"></i> Cancelar
            </button>
            <button type="button" class="btn btn-primary btn-lg text-uppercase px-4" @click="applyCustomPeriod">
              <b-spinner v-if="loading" small></b-spinner> Aplicar
            </button>
          </div>
        </div>
      </div>
    </b-modal>
    <b-modal id="show-modal-dashboard" ref="modalDashboard" size="md" class="mt-4" hide-footer centered>
      <template #modal-title>Definir Período Customizado</template>
      <div>
        <div class="row form">
          <div class="col-12">
            <label class="dbo-ui">Data de Início</label>
            <input type="date" class="form-control" v-model="filters_dashboard.start_date">
          </div>
          <div class="col-12">
            <label class="dbo-ui">Data de Fim</label>
            <input type="date" class="form-control" v-model="filters_dashboard.end_date">
          </div>
        </div>
        <div class="d-block mt-3">
          <div class="d-flex justify-content-between">
            <button @click="$bvModal.hide('show-modal-dashboard')" class="btn btn-secondary btn-lg px-4 mr-1">
              <i class="fa fa-times mr-1"></i> Cancelar
            </button>
            <button type="button" class="btn btn-primary btn-lg text-uppercase px-4" @click="applyCustomPeriod">
              <b-spinner v-if="loading" small></b-spinner> Aplicar
            </button>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>


<script>
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import KanbanPolicyRenewal from './RenewPolicy/KanbanPolicyRenewal.vue';
import ListPolicyRenewal from './RenewPolicy/ListPolicyRenewal.vue';
import DashboardPolicyRenewal from './RenewPolicy/DashboardPolicyRenewal.vue';
import policyService from "@/services/policy";
import policyRenovationService from "@/services/policy-renovation";
import translateReasonCancelTypes from "@/enums/translate/reasonCancelTypes";
import translateRenovationStatus from "@/enums/translate/renovationStatus";

export default {
  name: "BasePolicyRenewal",
  components: {
    KanbanPolicyRenewal,
    ListPolicyRenewal,
    DashboardPolicyRenewal
  },
  data() {
    return {
      currentMode: localStorage.getItem('policy-renewal-view-mode') || 'painel',
      dashboardTab: 'realizadas',
      itemsPolicies: [],
      itemsPolicyRenovation: [],
      isKanbanView: true,
      loading: false,
      requestCounter: 0,
      translateReasonCancelTypes: translateReasonCancelTypes,
      translateRenovationStatus: translateRenovationStatus,
      pages: {
        1: { current_page: 1, last_page: 1 },
        2: { current_page: 1, last_page: 1 },
        15: { current_page: 1, last_page: 1 },
        16: { current_page: 1, last_page: 1 },
        18: { current_page: 1, last_page: 1 },
        9: { current_page: 1, last_page: 1 },
      },
      filters: {
        policy_holder: '',
        insured: '',
        policy_number: '',
        status_renovation: '',
        reason_cancellation: ''
      },
      filters_dashboard: {
        start_date: '',
        end_date: ''
      },
      reasons_cancellation: [],
      status_renovations: [],
    };
  },
  created() {
    this.updateKanban();
  },
  methods: {
    setViewMode(mode) {
      this.currentMode = mode;
      localStorage.setItem('policy-renewal-view-mode', mode);
    },
    applyFilters() {
      if (this.currentMode === 'listagem' && this.$refs.listagem) {
        console.log(this.filters)
        this.$refs.listagem.currentPage = 1;
        this.$refs.listagem.getPoliciesRenovationsList(
          this.filters.policy_holder,
          this.filters.insured,
          this.filters.policy_number,
          this.filters.status_renovation,
          this.filters.reason_cancellation,
          true
        );
    } else {
      this.updateKanban();
    }
      this.$bvModal.hide('filter-modal');
    },
    openFilterModal() {
      this.$bvModal.show('filter-modal');
    },
    clearFilters() {
      this.filters.policy_holder = '';
      this.filters.insured = '';
      this.filters.policy_number = '';
      this.filters.status_renovation = '';
      this.filters.reason_cancellation = '';
      if (this.currentMode === 'listagem' && this.$refs.listagem) {
        this.$refs.listagem.currentPage = 1;
        this.$refs.listagem.getPoliciesRenovationsList(
          this.filters.policy_holder,
          this.filters.insured,
          this.filters.policy_number,
          this.filters.status_renovation,
          this.filters.reason_cancellation,
          true,
        );
      } else {
        this.updateKanban();
      }
    },
    clearFiltersModalDashboard() {
      this.filters_dashboard.start_date = '';
      this.filters_dashboard.end_date = '';
      this.customStartDate = '';
      this.customEndDate = '';

      if (this.$refs.dashboard) {
        this.$refs.dashboard.getDashboardPoliciesDue();
      }

      this.$refs.modalDashboard.hide();
    },

    updateKanban() {
      this.getPoliciesDue(60, -5);
      this.getPoliciesDue(120, 60);
      this.getPoliciesRenovations(15);
      this.getPoliciesRenovations(18);
      this.getPoliciesRenovations(16);
      this.getPoliciesRenovations(9);
    },
    checkIfAllRequestsComplete() {
      this.requestCounter++;
      if (this.requestCounter === 6 && this.currentMode == 'listagem') {
        this.$refs.listagem.allPolicies;
        this.$refs.listagem.totalPolicies;
        this.$refs.listagem.paginatedPolicies;
        this.requestCounter = 0;
      }
    },
    getPoliciesDue(due_days = 0, start_days = 0, page=1) {
      page != 1 ? '' : this.loading = true;
      policyService.getPoliciesDue({
        due_days,
        start_days,
        no_renewals: true,
        policy_holder: this.filters.policy_holder,
        insured: this.filters.insured,
        policy_number: this.filters.policy_number,
        status_renovation: this.filters.status_renovation,
        reason_cancellation: this.filters.reason_cancellation,
        view_mode: this.currentMode,
        page: page,
      })
        .then(response => {
          if (!response.data.error) {
            const column = (due_days > 60) ? 1 : 2;
            if(this.currentMode == 'painel') {
              if (page != 1) {
                this.$refs.painel.setloadingColum(column);
                let data = this.itemsPolicies[column];
                let merged = data.concat(response.data.data);
                this.$set(this.itemsPolicies, column, merged);
              } else {
                this.loading = true;
                this.$set(this.itemsPolicies, column, response.data.data);
              }
            }else if(this.currentMode == 'listagem') {
              this.$set(this.itemsPolicies, column, response.data);
            }

            this.pages[column].last_page = response.data.last_page;
            this.pages[column].current_page = response.data.current_page;
          }
        })
        .catch(() => {
          this.showError("Não foi possível recuperar as apólices a vencer.");
        })
        .finally(() => {
          this.loading = false;
          this.checkIfAllRequestsComplete();
        });
    },
    getPoliciesRenovations(status, page = 1) {
      page != 1 ? '' : this.loading = true;
      policyRenovationService.get({
        status_id: status,
        policy_holder: this.filters.policy_holder,
        insured: this.filters.insured,
        policy_number: this.filters.policy_number,
        status_renovation: this.filters.status_renovation,
        reason_cancellation: this.filters.reason_cancellation,
        view_mode: this.currentMode,
        page: page,
      })
      .then(response => {
        if (!response.data.error) {
          if(this.currentMode == 'painel') {
            if (page != 1) {
              this.$refs.painel.setloadingColum(status);
              let data = this.itemsPolicyRenovation[status];
              let merged = data.concat(response.data.data);
              this.$set(this.itemsPolicyRenovation, status, merged);
            } else {
              this.loading = true;
              this.$set(this.itemsPolicyRenovation, status, response.data.data);
            }
          }else if(this.currentMode == 'listagem') {
            this.$set(this.itemsPolicyRenovation, status, response.data);
          }

          this.pages[status].last_page = response.data.last_page;
          this.pages[status].current_page = response.data.current_page;
        }
      })
      .catch(() => {
        this.showError("Não foi possível recuperar as renovações.");
      })
      .finally(() => {
        this.loading = false;
        this.checkIfAllRequestsComplete();
      });
    },
    getIcon(currentMode) {
      if(currentMode === 'listagem') {
        return 'mdi mdi-view-list';
      }
      if(currentMode === 'painel') {
        return 'mdi mdi-file-table-box-multiple-outline';
      }
      return 'mdi fa-fw mdi-chart-arc';
    },
    setLoading(status) {
      this.loading = status;
    },
    showModalDashboard() {
      this.$refs.modalDashboard.show();
    },
    applyCustomPeriod() {
      // this.filters_dashboard.start_date = this.customStartDate;
      // this.filters_dashboard.end_date = this.customEndDate;

      this.$refs.modalDashboard.hide();

      if (this.$refs.dashboard) {
        this.$refs.dashboard.getDashboardPoliciesDue();
      }
    },
    createRenovation(policyRenewSelected) {
      this.loading_create = true;
      if (!policyRenewSelected) {
        this.showError('Não foi possível iniciar a renovação.');
        return;
      }
      policyRenovationService
        .store(policyRenewSelected.id)
        .then((response) => {
          if (response.data.error) {
            this.showError(response.data.message);
            return;
          }

          this.redirect('garantee-data', {
            quotationId: response.data.quotation_id,
          })
        })
        .catch(() => {
          this.showError('Não foi possível renovar a apólice.');
        })
        .finally(() => {
          policyRenewSelected = {};
          this.loading_create = false;
          this.$refs.modalCreate.hide();
        });
    },
    showError(message) {
      this.$bvToast.toast(message, {
        title: 'Erro',
        variant: 'danger_toast',
        solid: true,
        toastClass: 'custom-toast',
        bodyClass: 'custom-toast-body',
        appendToast: true,
        autoHideDelay: 5000,
      });
    },
    getNonRenewals() {
      this.loading = true;
      policyRenovationService
        .getNonRenewals()
        .then((response) => {
          if (response.data.error) {
            this.showError(response.data.message);
            return;
          }
          console.log(response.data)
          this.exportNonRenewalsToExcel(response.data)
        })
        .catch((err) => {
          console.log("🚀 ~ getNonRenewals ~ err:", err)
          this.showError('Não foi recuperar apolices não renovadas.');
        })
        .finally(() => {
          this.loading = false;
        });
    },
    exportNonRenewalsToExcel(items) {
      const rows = items.map(r => ({
        'Número Apólice': r.policy_number,
        'Tomador':        r.holder,
        'Motivo':         r.reason,
        'Segurado':       r.insured_name,
        'Premio': r.insurance_premium,
        'IS': r.coverage_value,
        'Data Inicio': r.validity_start,
        'Data Fim': r.validity_expiration,
      }));

      const ws = XLSX.utils.json_to_sheet(rows, {
        header: ['Número Apólice','Tomador','Motivo', 'Segurado', 'IS', 'Premio', 'Data Inicio', 'Data Fim']
      });

      ws['!cols'] = [
        { wch: 15 },
        { wch: 30 },
        { wch: 50 }
      ];

      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Não Renovadas');

      const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
      const blob = new Blob([wbout], { type: 'application/octet-stream' });
      saveAs(blob, `policies_non_renewals_${Date.now()}.xlsx`);
    },
  },
  watch: {
    '$route.query': {
      immediate: true,
      handler(query) {
        if (query.policyNumber) {
          this.filters.policy_number = query.policyNumber;
        }
      }
    }
  },
};
</script>
<style scoped>
/* Nav tabs do dashboard — sobrepõe Bootstrap para o contexto do header escuro */
.dashboard-nav-tabs {
  border-bottom: none;
  margin-bottom: 0;
}

.dashboard-nav-tabs .nav-link {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  font-weight: 400;
  color: #3f769d;
  border: 1px solid transparent;
  border-radius: 0;
  cursor: pointer;
  background-color: transparent;
  transition: color 0.15s, background-color 0.15s, border-color 0.15s;
  text-decoration: none;
}

.dashboard-nav-tabs .nav-link:hover {
  color: #fff;
  border-color: rgba(255,255,255,0.15) rgba(255,255,255,0.15) transparent;
}

.dashboard-nav-tabs .nav-link.active {
  color: #1a2c47;
  font-weight: 500;
  background-color: #fff;
  border-color: #dee2e6 #dee2e6 #fff;
}
</style>
